import { Suppliers as Page } from './Suppliers.main';
import { SuppliersHeader as Header } from './SuppliersHeader';

export { Filters } from './Filters';
export { SuppliersTable } from './SuppliersTable';

export const Suppliers = { Header, Page };
